import { createSelector } from 'reselect';
var selectState = function (state) { return state.get('intl'); };
export var selectAll = createSelector(selectState, function (state) {
    return state.get('data');
});
export var selectCurrentLanguage = createSelector(selectState, function (state) {
    return state.get('currentLanguage');
});
